import React from 'react';

import { RouteObject } from 'react-router-dom';
import MainPages from 'pages/main';
import ShopPage from 'pages/main/shop';
import HistoryPage from 'pages/main/history';
import LoginPage from 'pages/login';
import AdminPage from 'pages/main/admin/AdminPage';
import RatingPage from 'pages/main/rating/RatingPage';

export const routes: RouteObject[] = [
    {
        path: 'login',
        element: <LoginPage />,
    },
    {
        element: <MainPages />,
        children: [
            {
                index: true,
                element: <ShopPage />,
            },
            {
                path: 'history',
                element: <HistoryPage />,
            },
            {
                path: 'admin',
                element: <AdminPage />,
            },
            {
                path: 'rating',
                element: <RatingPage />,
            },
        ],
    },
];

export default routes;
